/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */
import { getApiKey, getAppEntityToken, getSource } from '../api';

export const resolveConnexCredentials = () => {
  const appEntityToken = getAppEntityToken();

  return {
    entityRef: appEntityToken?.entityRef,
    token: appEntityToken?.value,
    apiKey: getApiKey(getSource()),
  };
};
